import React from "react";
import CourseCategoryPage from "../components/CourseCategoryPage";
import { getSky } from "../services/api";

function Skydive() {
  return (
    <CourseCategoryPage
      queryKey="sky"
      fetchFn={getSky}
      popupStorageKey="skypage_popup_dismissed_this_tab"
      errorMessage="Failed to load skydive courses."
    />
  );
}

export default Skydive;
